import { FC } from 'react';
import { BgFilterStyled } from './style';

const BackgroundFilter: FC<{ rtl?: boolean }> = ({ children, rtl, ...restProps }) => (
  <BgFilterStyled rtl={rtl} {...restProps}>
    {children}
  </BgFilterStyled>
);

export default BackgroundFilter;
